import { accountSummaryV2Url } from "./endpoints.js";
const accountSummaryV2CacheKey = ({
  accountId,
  accountIdType
}) => [accountSummaryV2Url, { accountId, accountIdType }];
export {
  accountSummaryV2CacheKey
};
//# sourceMappingURL=cacheKeys.js.map
